/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { DtoTravelAssignmentCreate } from '../../models/dto-travel-assignment-create';
import { TravelAssignment } from '../../models/travel-assignment';

export interface TravelControllerCreateAssignment$Params {
  id: number;
      body: DtoTravelAssignmentCreate
}

export function travelControllerCreateAssignment(http: HttpClient, rootUrl: string, params: TravelControllerCreateAssignment$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: TravelAssignment;
}>> {
  const rb = new RequestBuilder(rootUrl, travelControllerCreateAssignment.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: TravelAssignment;
      }>;
    })
  );
}

travelControllerCreateAssignment.PATH = '/travel/draft/{id}/assign-request';
